export default {
  businessLogisticsCompanyList: {
    table: {
      orderNumber: 'Serial number',
      logisticsCompanyNameInput: 'Please enter logistics provider name',
    },
    editLogisticsCompany: 'Edit Logistics Provider',
    addLogisticsCompany: 'Create LogisticsProvider',
    Not: 'Not imported',
    Imported: 'Imported',
    To: 'To be imported',
    be: 'To be written back',
    Uploaded: 'Uploaded',
    number: 'Job Id/Tracking No.',
    name: 'Logistics name',
    status: 'Logistics status',
    or: 'Import Or Not',
    batchEmail: 'Batch Send Email',
    batchDone: 'Batch Done',
    email: 'Send Email',
    done: 'Complete',
    ps1: 'Only logistics Business Name with ALLI also orders with incomplete are allowed to send emails',
    ps2: 'Only orders with incomplete logistics status can be completed',
  }
};

